import React from 'react';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';

import { api } from 'api';
import MonitoringWatchlistModalList from './MonitoringWatchlistModalList';
import Modal from './Modal';
import SearchBox from 'jsx/elements/inputs/SearchBox';
import Flex from 'jsx/layout/Flex';
import Button from 'jsx/elements/buttons/Button';
import useModalMinHeightFix from 'hooks/useModalMinHeightFix';

export default function MonitoringWatchlistModal({ closeModal, selected, canRemove }) {
  const [search, setSearch] = React.useState('');
  const [{ data, status }, setData] = React.useState({ data: [], status: 'loading' });
  const modalRef = React.useRef(null);
  const minHeight = useModalMinHeightFix(modalRef, data);

  const { t } = useLocale();
  React.useEffect(() => {
    api.monitor.loadWatchlist(selected.monitorId).then((res) => {
      setData({ status: 'loaded', data: res });
    });
  }, []);

  const filtered = React.useMemo(() => {
    if (search) {
      const lower = search.toLowerCase().replace('-', '');
      return data.filter((item) => {
        return item.name.toLowerCase().includes(lower) || item.regno.includes(lower);
      });
    }
    return data;
  }, [search, data]);

  async function remove(regno) {
    api.monitor.removeFromWatchlist(selected.monitorId, regno).then((res) => {
      if (!res) {
        setData({ status: 'loaded', data: data.filter((item) => item.regno !== regno) });
      }
    });
  }

  return (
    <Modal
      header={t('monitoring_watchlist_title', selected.name)}
      onCancelClick={closeModal}
      footer={
        <Flex justifyContent="flex-end" style={{ width: '100%' }}>
          <Button text={t('button_yes_close')} onClick={closeModal} />
        </Flex>
      }
      isOpen
    >
      <div ref={modalRef} style={{ minHeight }}>
        <div style={{ maxWidth: 300 }}>
          <SearchBox
            placeholder={t('portfolio_exclusion_searchbox_placeholder')}
            onChange={(e) => setSearch(e.target.value)}
            value={search}
          />
        </div>
        <MonitoringWatchlistModalList
          customerList={filtered}
          canRemove={canRemove}
          loading={status === 'loading'}
          onRemove={remove}
        />
      </div>
    </Modal>
  );
}
